import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { FaRegRectangleXmark, FaSquarePlus } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import { eiwrsDepotManagementServices } from "../../../../APIServices/EIWRS/eiwrsDepotManagementServices";

const AddDepotMetadataForm = ({ getStudyDepotColumnData }) => {
  const [columnLabel, setColumnLabel] = useState("");
  const [columnName, setColumnName] = useState("");
  const [columnType, setColumnType] = useState("");
  const [columnOption, setColumnOption] = useState([{ id: 1, option: "" }]);
  let { studyId } = useParams();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [required, setRequired] = useState("");

  const addNewStudyDepotColumn = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.columnLabel = columnLabel;
    userData.columnName = columnName;
    userData.columnType = columnType;
    userData.required = required;
    userData.columnOption =
      columnType === "dropdown" || columnType === "radio" ? columnOption : [];
    let data = await eiwrsDepotManagementServices.addNewStudyDepotColumn(
      userData
    );
    if (data?.statusCode === 200) {
      clearForm();
      getStudyDepotColumnData();
    }
    setButtonLoader(false);
  };

  const handleAddNewOption = () => {
    setColumnOption([
      ...columnOption,
      { id: columnOption?.length + 1, option: "" },
    ]);
  };

  const handleRemoveNewOption = (id) => {
    const updatedOptions = columnOption?.filter((option) => option.id !== id);
    setColumnOption(updatedOptions);
  };

  const handleSelectNewOptionChange = (id, value) => {
    const updatedOptions = columnOption?.map((option) =>
      option.id === id ? { ...option, option: value } : option
    );
    setColumnOption(updatedOptions);
  };

  const clearForm = () => {
    setColumnLabel("");
    setColumnName("");
    setRequired("");
    setColumnType("");
    setColumnOption([{ id: 1, option: "" }]);
  };

  useEffect(() => {
    clearForm();
  }, []);

  const isDisabled =
    !columnLabel ||
    !columnName ||
    !columnType ||
    !required ||
    (columnType === "dropdown" || columnType === "radio"
      ? (columnOption || [])?.some((item) => item.option === "")
      : false);

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Column Label{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setColumnLabel(e.target.value)}
          value={columnLabel}
          className="br3"
          placeholder="Column Label"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Column Name{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => {
            const input = e.target.value
              .toUpperCase()
              .replace(/[^A-Z0-9]/g, "");
            setColumnName(input);
          }}
          onKeyDown={(e) => {
            if (e.key === " ") {
              e.preventDefault();
            }
          }}
          value={columnName}
          className="br3"
          placeholder="Column Name"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Column Type{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setColumnType(e.target.value)}
          style={{ fontSize: 12 }}
          className="br3"
        >
          <option selected={columnType === ""} value="">
            Select Type
          </option>
          <option selected={columnType === "text"} value="text">
            Text
          </option>
          <option selected={columnType === "number"} value="number">
            Number
          </option>
          <option selected={columnType === "date"} value="date">
            Date
          </option>
          <option selected={columnType === "time"} value="time">
            Time
          </option>
          <option selected={columnType === "dropdown"} value="dropdown">
            Dropdown
          </option>
          <option selected={columnType === "radio"} value="radio">
            Radio
          </option>
        </Form.Select>
      </Form.Group>
      {(columnType === "dropdown" || columnType === "radio") && (
        <Form.Group className="mb-1">
          <Form.Label className="fw-bold mb-1">
            Column Option{" "}
            <FaSquarePlus
              className="CP"
              title="Add Option"
              onClick={handleAddNewOption}
            />
          </Form.Label>
          {columnOption?.map((item, index) => (
            <div key={index} className="hstack gap-2 mb-2">
              <Form.Control
                onChange={(e) =>
                  handleSelectNewOptionChange(item?.id, e.target.value)
                }
                value={item?.option}
                className="br3"
                placeholder={`Column Option ${index + 1}`}
                type="text"
              />
              {columnOption?.length > 1 && (
                <FaRegRectangleXmark
                  onClick={(e) => handleRemoveNewOption(item?.id)}
                  style={{ fontSize: 16 }}
                  className="CP text-danger"
                />
              )}
            </div>
          ))}
        </Form.Group>
      )}
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Required{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Select
          onChange={(e) => setRequired(e.target.value)}
          style={{ fontSize: 12 }}
          className="br3"
        >
          <option selected={required === ""} value="">
            Select Type
          </option>
          <option selected={required === "yes"} value="yes">
            Yes
          </option>
          <option selected={required === "no"} value="no">
            No
          </option>
        </Form.Select>
      </Form.Group>
      <div className="text-end">
        <button
          disabled={isDisabled || buttonLoader}
          title={isDisabled ? "Fill all required fields" : "Add Metadata"}
          onClick={addNewStudyDepotColumn}
          className={`updateProfile`}
          style={{ fontSize: 12 }}
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm"/> Adding...
            </div>
          ) : (
            "Add new depot metadata"
          )}
        </button>
      </div>
    </div>
  );
};

export default AddDepotMetadataForm;
